const waterMeterTypes = {
	TV: {
		id: 'TV',
		cold: false,
		name: 'Teplá voda'
	},
	SV: {
		id: 'SV',
		cold: true,
		name: 'Studená voda'
	},
	SV_K: {
		id: 'SV_K',
		cold: true,
		name: 'Studená voda KUCHYŇA'
	},
	TV_K: {
		id: 'TV_K',
		cold: false,
		name: 'Teplá voda KUCHYŇA'
	},
	SV_G: {
		id: 'SV_G',
		cold: true,
		name: 'Studená voda PIVNICA/GARÁŽ'
	},
	TV_G: {
		id: 'TV_G',
		cold: false,
		name: 'Teplá voda PIVNICA/GARÁŽ'
	},
	SV_WC: {
		id: 'SV_WC',
		cold: true,
		name: 'Studená voda WC'
	},
	TV_WC: {
		id: 'TV_WC',
		cold: false,
		name: 'Teplá voda WC'
	},
	UNDEFINED: {
		id: undefined,
		name: 'Neznámy typ',
		cold: undefined
	}
}

const getWaterMeterById = (id) => {
	switch (id) {
		case 'SV':
			return waterMeterTypes.SV
		case 'TV':
			return waterMeterTypes.TV
		case 'SV_K':
			return waterMeterTypes.SV_K
		case 'TV_K':
			return waterMeterTypes.TV_K
		case 'SV_G':
			return waterMeterTypes.SV_G
		case 'TV_G':
			return waterMeterTypes.TV_G
		case 'SV_WC':
			return waterMeterTypes.SV_WC
		case 'TV_WC':
			return waterMeterTypes.TV_WC
		default:
			return waterMeterTypes.UNDEFINED
	}
}

module.exports = {
	getWaterMeterById,
	waterMeterTypes
}
